// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1Vqkg","dragIcon":"Choice_dragIcon__38Ss2","left":"Choice_left__LX2CS","input":"Choice_input__2E_Z6"};